<template>
  <div class="edit-contact">
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column">
                    <h1 class="edit-contact__title page-title title is-4 has-padding-v-50">Contact Details</h1>
                </div>
            </div>
            <div class="columns">
                <div class="column is-one-third edit-contact__header container">
                  <h2 class="title is-5">Please enter {{ jobName }} details</h2>
                  <span v-html="jobNote"></span>
                </div>
                <div class="column box edit-contact__box container">
                    <div class="errors" v-if="errors.length">
                        <ul>
                            <li v-for="err in errors">
                              {{ err }}
                            </li>
                        </ul>
                    </div>
                    <div class="block">
                        <div class="field">
                            <label class="label">Name</label>
                            <div class="control">
                                <input class="input" type="text" v-model="supplier[$route.params.id].name">
                            </div>
                        </div>
                    </div>
                    <div class="block">
                        <div class="field">
                            <label class="label">Job title</label>
                            <div class="control">
                                <input class="input" type="text" v-model="supplier[$route.params.id].jobTitle">
                            </div>
                        </div>
                    </div>
                    <div class="block">
                        <div class="field">
                            <label class="label">E-mail</label>
                            <div class="control">
                                <input class="input" type="text" v-model="supplier[$route.params.id].email">
                            </div>
                        </div>
                    </div>
                    <div class="block">
                        <div class="field">
                            <label class="label">Phone/skype number</label>
                            <div class="control">
                                <input class="input" type="text" v-model="supplier[$route.params.id].phone">
                            </div>
                        </div>
                    </div>
                    <div class="edit-contact__btn-finish">
                        <a class="button btn-next" @click.prevent="save">Finish</a>
                    </div>
                </div>
            </div>
            <b-loading :is-full-page="true" :active="isLoading"></b-loading>
        </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import api from '../libs/api';
import sendEvent from '../libs/sendEvent';
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export default {
  name: 'editcontact',
  data() {
    return {
      jobNames: {
        authorised: 'Authorised',
        general: 'General',
        technical: 'Coder',
      },
      requiredFields: {
        "Please enter a name": "name",
        "Email": "email",
        "Please enter a job title": "jobTitle",
        "Please enter a phone number": "phone"
      },
      jobName: '',
      jobNotes: {
        authorised: '',
        general: '',
        technical: 'Note: this should be the person who is actually performing the technical work to integrate your product with BestAgent Marketplace. <b>eg. IT person, developer or technical person</b>',
      },
      jobNote: '',
      isLoading: false,
      errors: [],
      supplier: {
        company: null,
        authorised: {
          name: '',
          email: '',
          jobTitle: '',
          phone: '',
        },
        general: {
          name: '',
          email: '',
          jobTitle: '',
          phone: '',
        },
        technical: {
          name: '',
          email: '',
          jobTitle: '',
          phone: '',
        },
      },
    };
  },
  async created() {
    this.jobName = this.jobNames[this.$route.params.id];
    this.jobNote = this.jobNotes[this.$route.params.id];
    this.supplier = await api({
      endpoint: `${process.env.VUE_APP_API}/suppliers`,
      path: '/info',
      method: 'GET',
    });
    if (!this.supplier.authorised) {
      this.supplier.authorised = {
        name: '',
        email: '',
        jobTitle: '',
        phone: '',
      };
    }
    if (['authorised', 'general', 'technical'].indexOf(this.$route.params.id) === -1) {
      this.$router.push('/');
    }
  },
  methods: {
    async save() {
      const that = this;
      if (this.isLoading == true) {
        return false;
      }
      this.isLoading = true;

      let required = [];
      const keys = Object.keys(this.requiredFields);
      await Promise.all(keys.map(k => {
        try {
          let revar = that.supplier[that.$route.params.id][that.requiredFields[k]];
          if (!revar || revar == '') {
            required.push(k);
          } else if (k == 'Email' && !validateEmail(revar)) {
            required.push('Please validate the email address.');
          }
        } catch (e) {
          required.push(k);
        }
      }));
      if (required.length) {
        this.errors = required;
        this.isLoading = false;
        return false;
      }
      this.errors = [];

      try {
        await api({
          endpoint: `${process.env.VUE_APP_API}/suppliers`,
          path: '/',
          method: 'PUT',
          body: this.supplier,
        });
        this.isLoading = false;
        this.$router.push('/account');
      } catch (err) {
        /*
        await sendEvent({
          type: 'ERROR-SUPPLIERS-FRONT-SAVE-SUPPLIER',
          itemData: this.supplier,
          errorMessage: err,
        });
        */
        this.isLoading = false;
        console.log('Error:', err);
      }
    },
  },
};
</script>

<style lang="scss">
.errors {
  color:red
}
.errors ul {
  list-style-type: none;
}

.boxedit {
  font-size:17px;
  line-height: 17px;
  padding-left:10%
}

.card.company-card {
  max-width: 400px !important;
}

</style>
